import { render, staticRenderFns } from "./socialMediaFooter.vue?vue&type=template&id=178d9865"
import script from "./socialMediaFooter.vue?vue&type=script&lang=js"
export * from "./socialMediaFooter.vue?vue&type=script&lang=js"
import style0 from "./socialMediaFooter.vue?vue&type=style&index=0&id=178d9865&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports